// eslint-disable-next-line canonical/filename-match-exported
const variables: Variables = {
  'Забронирован': {
    base: 'rgba(234,107,21,.8)',
    hover: 'rgba(234,107,21,.4)',
  },
  'Свободен': {
    base: 'rgba(10,143,10,.8)',
    hover: 'rgba(10,143,10,.4)',
  },
  'Акция': {
    base: 'rgba(52,152,219,.8)',
    hover: 'rgba(52,152,219,.4)',
  },
  'Продан': {
    base: 'rgba(255,0,0,.4)',
    hover: 'rgba(255,0,0,.3)',
  },
  'Спецпредложение': {
    base: 'rgba(132,58,242,0.8)',
    hover: 'rgba(132,58,242,0.4)',
  },
  'Ипотека': {
    base: 'rgba(223,17,162,0.6)',
    hover: 'rgba(223,17,162,0.4)',
  },
  'unset': {
    base: 'rgba(255,255,255,.1)',
    hover: 'rgba(255,255,255,.1)',
  },
}

export default variables

// Статусы, с которыми юзерам можно просматривать информацию / взаимодействовать
export const allowedStates = [
  'free',
  'hold',
  'discount',
  'special',
  'mortgage',
]

export type Variables = {
  [key: string]: {
    base: string;
    hover: string;
  };
}
